import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { CommonFormComponent } from '../../../public-api';
import { CustomValidators } from '../../utilities/customer_validators';
import { ValidatorFn, Validators } from '@angular/forms';
import { I18nService } from '../../services/i18n.service';
import { AuthenticationService } from '../../services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { App_Routes } from '../../enums/router.enum';
import { FormKey } from '../../enums/i18.enum';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { LP_UI_CONFIG } from '../../core/tokens';
import { UiService } from '../../../public-api';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RouterModule } from '@angular/router';
import { NzImageModule } from 'ng-zorro-antd/image';
export interface FormField {
  controlName: any;
  label: any;
  controlType: 'text' | 'number' | 'select' | 'password';
  placeholder?: any;
  validators?: ValidatorFn[];
  options?: any[]; // Required for 'select' type
  initialValue?: any;
}

@Component({
  selector: 'app-forget-password-email',
  imports: [CommonFormComponent, NzIconModule, NzImageModule, RouterModule],
  templateUrl: './forget-password-email.html',
  styleUrl: './forget-password-email.scss',
})
export class ForgetPasswordEmail implements OnInit {
  success = signal<boolean>(false);
  error = signal<boolean>(false);
  token: any;
  authorized = false;
  authorizing = false;
  public cfg = inject(LP_UI_CONFIG);
  private route = inject(ActivatedRoute);
  i18n = inject(I18nService);
  private auth = inject(AuthenticationService);
  private router = inject(Router);
  public changePasswordForm = new CommonFormComponent();
  public ui = inject(UiService);
  isMobile = computed(() => this.ui.IsMobile());

  formConfiguration = computed<FormField[]>(() => [
    {
      controlName: FormKey.Password,
      label: FormKey.LabelNewPassword,
      controlType: 'password' as const,
      placeholder: FormKey.LabelNewPassword,
      initialValue: null,
      validators: [...CustomValidators.strongPassword],
    },
    {
      controlName: FormKey.ConfirmPassword,
      label: FormKey.LabelRepeatPassword,
      controlType: 'password' as const,
      placeholder: FormKey.LabelRepeatPassword,
      initialValue: null,
      validators: [Validators.required],
    },
  ]);
  get isLoggedIn(): boolean {
    return this.auth.isLoggedIn();
  }

  ngOnInit() {
    if (!this.isLoggedIn) {
      this.route.params.subscribe((params) => {
        this.token = GLOBAL_CONSTANT.EMPTY_STRING + params['token'];
        this.checkAuthorization();
      });
    }
  }

  checkAuthorization() {
    this.authorized = false;
    this.authorizing = true;
    this.auth.checkForgotPasswordToken(this.token).subscribe(
      (isAuth) => {
        this.authorized = isAuth;
        this.authorizing = false;
      },
      (error) => {
        console.error(error);
        this.authorized = false;
        this.authorizing = false;
      }
    );
  }

  onRequestNewMail() {
    const email = this.getMailFromToken();
    this.router.navigate(['login', 'forgotpw', email]);
  }

  getMailFromToken() {
    try {
      return JSON.parse(atob(this.token.split('.')[1])['replaceAll']("'", '"')).email;
    } catch (_e: any) {
      return _e;
    }
  }

  setNewPassword(formData: { currentPassword: string; password: string }) {
    // if (!this.authorized && !this.isLoggedIn) return;
    this.success.set(false);
    this.error.set(false);

    if (this.isLoggedIn) {
      this.auth.setNewPasswordViaSettings(formData.currentPassword, formData.password).subscribe(
        (res) => {
          if (res) {
            this.success.set(true);
          } else {
            this.error.set(true);
          }
        },
        (error) => {
          console.error(error);
          this.error.set(true);
        }
      );
    } else {
      this.auth.setNewPasswordViaEmail(this.token, formData.password).subscribe(
        (res) => {
          if (res) {
            this.success.set(true);
            this.router.navigate([App_Routes.LOGIN, App_Routes.PW_CHANGED]);
          } else {
            this.error.set(true);
          }
        },
        (error) => {
          console.error(error);
          this.error.set(true);
        }
      );
    }
  }
}
